import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchLoggedInUserOrdersAsync } from "../userSlice";
import { loggedInUser } from "../../Auth/Auth_Slice";
import Loader from "../../../components/Common/Loader";
const formatNumber = (number) => {
    if (number) {
        let x = number;
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    }
}

function MyOrders() {
    const user = useSelector(loggedInUser);
    const dispatch = useDispatch();
    const orders = useSelector((state) => state.user.userOrders);
    const orderStatus = useSelector((state) => state.user.status);


    const getStatusString = (status) => {
        switch (status) {
            case 1:
                return 'Order Placed';
            case 2:
                return 'Processing';
            case 3:
                return 'Shipped';
            case 4:
                return 'Delivered';
            default:
                return 'Undefined';
        }
    }

    const statusBackground = (statusCode) => {
        switch (statusCode) {
            case 1:
                return 'text-yellow-900 bg-yellow-200';
            case 2:
                return 'text-sky-900 bg-sky-200';
            case 3:
                return 'text-purple-900 bg-purple-200';
            case 4:
                return 'text-green-900 bg-green-200';
            default:
                return 'Undefined';
        }
    }


    useEffect(() => {
        if (!orders || orders.length === 0) {
            dispatch(fetchLoggedInUserOrdersAsync(user.id))
        }
    }, [orders, dispatch, user.id])
    return (orderStatus === "loading" ? (
        <div className="w-full flex justify-center px-2 md:px-4 py-5">
            <Loader />
        </div>
    )
        : (orders && orders.length > 0 ? (
            <div className="w-full overflow-x-auto rounded-lg border border-gray-200 my-5 shadow-sm">
                <table className="min-w-[650px] w-full leading-normal">
                    <thead className="bg-gray-50 border-b border-gray-200">
                        <tr className="text-gray-600 font-semibold uppercase text-left text-xs tracking-wider">
                            <th className="px-5 py-4"> Product </th>
                            <th className="px-5 py-4"> Price </th>
                            <th className="px-5 py-4"> Status </th>
                            <th className="px-5 py-4 text-right"> Info </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {orders && orders.map(itemsArray => (itemsArray.items.map(item => (
                            <tr key={item.productId} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                                <td className="px-5 py-5 text-sm">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0 w-14 h-14 border border-gray-100 rounded-md p-1">
                                            <img className="w-full h-full object-contain" src={item.images[0]} alt={item.imageAlt} />
                                        </div>
                                        <div className="ml-4">
                                            <Link to={`/${item.href}/${item.productId}`} className="text-gray-900 hover:text-indigo-600 font-bold block leading-tight">
                                                {item.name}
                                            </Link>
                                            <div className="mt-1 flex gap-2">
                                                {item.color && <span className="text-[10px] bg-gray-100 px-1.5 py-0.5 rounded text-gray-500 capitalize">Color: {item?.color}</span>}
                                                {item.size && <span className="text-[10px] bg-gray-100 px-1.5 py-0.5 rounded text-gray-500 uppercase">Size: {item?.size}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-5 py-5 text-sm">
                                    <p className="text-gray-900 font-bold">₹{formatNumber(item.price)}</p>
                                </td>
                                <td className="px-3 md:px-5 py-5 bg-white text-sm">
                                    <span className={`inline-block px-3 py-1 font-bold text-[11px] uppercase tracking-wider whitespace-nowrap ${statusBackground(itemsArray.status)} rounded-full shadow-sm`}>
                                        {getStatusString(itemsArray.status)}
                                    </span>
                                </td>
                                <td className="px-5 py-5 text-sm text-right">
                                    <Link to={`/account/orders/${itemsArray?.orderId}`} className="text-indigo-600 font-bold hover:underline">
                                        Details
                                    </Link>
                                </td>
                            </tr>
                        ))))}
                    </tbody>
                </table>
            </div>
        )
            : (
                <div className="flex py-10 justify-center flex-col basis-full items-center space-y-2">
                    <img src="/no-product.svg" alt="no review-rating" className="w-44" />
                    <div className="space-y-2 text-center">
                        <p className="text-xl font-medium tracking-tight text-gray-900">No Orders Found</p>
                        <p className="text-sm font-medium tracking-tight text-gray-600">Looks like you haven't made any order yet!</p>
                    </div>
                </div>
            )
        )
    )
}


export default MyOrders;
